module.exports = __webpack_public_path__ + "static/testimonial-2-9c5342104a2e895156dfab85d1436a93.png";